import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2656488277/src/dharmayana-website/src/components/Articles/ArticleList.tsx");
